!(function (t, e) {
  'function' == typeof define && define.amd
    ? define('../src/pinlogin', [], e)
    : 'object' == typeof module && module.exports
      ? (module.exports = e())
      : (t.Pinlogin = e());
})(window, function t() {
  var e = 'pinlogin';
  function t(t, i) {
    if (
      ((this.elementId = t.id),
      (this.defaults = {
        fields: 5,
        placeholder: '•',
        autofocus: !0,
        hideinput: !0,
        reset: !0,
        pattern: '^[0-9]*$',
        copypaste: !0,
        complete: function (t) {},
        invalid: function (t, e) {},
        keydown: function (t, e, i) {},
        input: function (t, e, i) {},
      }),
      (this.settings = this.defaults),
      i)
    )
      for (var s in i) this.settings[s] = i[s];
    var n = this._createElement('div', { id: t.id + '_' + e, class: [e] });
    ((this.values = []), (this.timers = []));
    for (var a = 0; a < this.settings.fields; a++) {
      var o = this._createInput(this.getFieldId(a), a);
      (this._attachEvents(o, a), n.appendChild(o));
    }
    (t.appendChild(n), this.reset(), this.settings.autofocus && this.focus(0));
  }
  return (
    (t.prototype._createElement = function (t, e) {
      var i = document.createElement(t);
      for (var s in e) 'class' == s ? i.classList.add.apply(i.classList, e[s]) : i.setAttribute(s, e[s]);
      return i;
    }),
    (t.prototype._createInput = function (t, e) {
      return this._createElement('input', {
        id: t,
        name: t,
        type: 'text',
        maxlength: 0 === e ? this.settings.fields : 1,
        inputmode: 'numeric',
        'x-inputmode': 'numeric',
        autocomplete: 0 === e ? 'one-time-code' : 'off',
        autocorrect: 'off',
        autocapitalize: 'off',
        spellcheck: !1,
        class: ['pinlogin-field'],
      });
    }),
    (t.prototype._attachEvents = function (t, e) {
      var i = this;
      (t.addEventListener('pointerdown', function () {
        this._intentional = true;
      }),
        t.addEventListener('focus', function () {
          if (this.readOnly || !this._intentional) return;

          this._intentional = false;
          this.value = '';
        }),
        t.addEventListener('input', function (t) {
          if (0 == e && this.value.length == i.settings.fields) {
            var s = this.value;
            for (var n = 0; n < i.settings.fields; n++) {
              var a = i.getField(n);
              a.removeAttribute('readonly');
              a.value = s[n];
              if (!i.validateInput(n)) break;
              if (n + 1 < i.settings.fields) i.focus(n + 1);
              else i.settings.complete(s);
            }
            return;
          }

          if (!i.validateInput(e)) {
            (t.preventDefault(), t.stopPropagation());
            return;
          }

          if ((i.settings.input(t, this, e), (i.values[e] = this.value), e < i.settings.fields - 1)) {
            if (i.settings.hideinput) {
              e > 0 && (i.getField(e - 1).value = i.settings.placeholder);
              var s = this;
              i.timers.push(
                setTimeout(function () {
                  s.value = i.settings.placeholder;
                }, 1e3),
              );
            }
            (i.getField(e + 1).removeAttribute('readonly'), i.focus(e + 1));
          } else {
            i.settings.hideinput && (this.value = i.settings.placeholder);
            var n = i.values.join('');
            (i.settings.reset && i.reset(), i.settings.complete(n));
          }
        }),
        t.addEventListener('keydown', function (t) {
          for (var s = 0; s < i.timers.length; s++) clearTimeout(i.timers[s]);
          ((i.timers = []),
            i.settings.keydown(t, this, e),
            (37 == t.keyCode || 8 == t.keyCode) &&
              e > 0 &&
              (i.resetField(e), i.focus(e - 1), t.preventDefault(), t.stopPropagation()));
        }),
        i.settings.copypaste &&
          0 == e &&
          t.addEventListener('paste', function (t) {
            var e, s;
            if (
              (t.stopPropagation(),
              t.preventDefault(),
              (s = (e = t.clipboardData || window.clipboardData).getData('Text').trim()).length == i.settings.fields)
            )
              for (var n = 0; n < i.settings.fields; n++) {
                var a = i.getField(n);
                if ((a.removeAttribute('readonly'), (a.value = s[n]), !i.validateInput(n))) break;
                n + 1 < i.settings.fields ? i.focus(n + 1) : i.settings.complete(s);
              }
          }));
    }),
    (t.prototype.validateInput = function (t) {
      var e = this.getField(t),
        i = RegExp(e.pattern || '^\\d$');
      return e.value.match(i)
        ? (e.classList.remove('invalid'), !0)
        : ((e.value = ''), e.classList.add('invalid'), this.settings.invalid(e, t), !1);
    }),
    (t.prototype.getFieldId = function (t) {
      return this.elementId + '_' + e + '_' + t;
    }),
    (t.prototype.getField = function (t) {
      return document.getElementById(this.getFieldId(t));
    }),
    (t.prototype.focus = function (t) {
      var f = this.getField(t);
      (this.enableField(t), f.focus());
    }),
    (t.prototype.reset = function () {
      this.values = Array(this.settings.fields);
      for (var t = 0; t < this.settings.fields; t++) {
        var e = this.getField(t);
        ((e.value = ''), e.classList.remove('invalid'));
      }
      this.settings.autofocus && this.focus(0);
    }),
    (t.prototype.resetField = function (t) {
      this.values[t] = '';
      var e = this.getField(t);
      ((e.value = ''), (e.readOnly = !0), e.classList.remove('invalid'));
    }),
    (t.prototype.disable = function () {
      for (var t = 0; t < this.settings.fields; t++) this.disableField(t);
    }),
    (t.prototype.disableField = function (t) {
      this.getField(t).readOnly = !0;
    }),
    (t.prototype.enable = function () {
      for (var t = 0; t < this.settings.fields; t++) this.enableField(t);
    }),
    (t.prototype.enableField = function (t) {
      this.getField(t).removeAttribute('readonly');
    }),
    'undefined' != typeof jQuery &&
      ($.fn[e] = function (i) {
        var s;
        return (
          this.each(function () {
            (s = $.data(this, e)) || ((s = new t(this, i)), $.data(this, e, s));
          }),
          s
        );
      }),
    t
  );
});
export default window.Pinlogin;
